import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { CARD_TYPES } from '../../../shared/constants';
import { IImage } from '../../../types/shared';

import mq from '../../../styles/breakpoints';

interface Props extends PropsWithChildren {
  image: IImage;
}

const ImageRow = ({ image }: Props) => (
  <Container data-testid="image-row" id={CARD_TYPES.imageRow}>
    {image && (
      <ImageContainer>
        <img alt={image.description || 'image'} src={image.file?.url} />
      </ImageContainer>
    )}
  </Container>
);

export default ImageRow;

const Container = styled.div`
  margin: 0;
`;

const ImageContainer = styled.div`
  display: flex;
  height: 104px;
  justify-items: center;
  width: 104px;

  img {
    height: inherit;
  }

  ${mq.from.breakpoint.M`
    width: 118px;
    height: 118px;
  `}
`;
